import { useEffect, useRef, useState } from 'react';
import { IonGrid, IonRow, IonCol, IonInput, IonButton, IonSegment, IonSegmentButton, IonLabel, useIonToast, IonIcon } from '@ionic/react';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { Constants } from '../../../../defines/Constants';
import { ValidateEmail, ValidateIranMobile, Countdown, TogglePassword, ConvertToEnDigit } from '../../../../defines/Functions';
import { SmsRetriever } from '@awesome-cordova-plugins/sms-retriever';
import moment from 'jalali-moment';
import axios from "axios";
import Loading from '../../../Loading';
import './Login.css';
import refreshImg from '../../../../assets/images/refresh.svg';

interface Props {
    loginForgotParentCallback: Function,
    isVerifyTempParentCallback: Function,
    loginErrorParentCallback: Function,
    closeModalParentCallback: Function,
    isLoginParentCallback: Function
}
const Login = (props: Props) => {
    const authVerifyTemp = Constants.api.authVerifyTemp;
    const authLoginByVerifyCode = Constants.api.authLoginByVerifyCode;
    const authLogin = Constants.api.authLogin;
    const profileInfo = Constants.api.profileInfo;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        });
    };
    const [loading, setLoading] = useState(false);
    const [loginFormData, setLoginFormData] = useState({
        username: '',
        password: '',
        verify_code: ''
    });
    const [required, setRequired] = useState({
        username: { value: false, message: '' },
        password: { value: false, message: '' },
        verify_code: { value: false, message: '' }
    });
    const [state, setState] = useState({
        segValue: 'code',
        showVerifyCode: false,
        showVerifyCounter: false
    });
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setLoginFormData(values => ({ ...values, [name]: value }));
    }
    const handleLoginSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (loginFormData.username.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, username: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            let errorCount = 0;
            let errorMessage = '';
            if (!ValidateIranMobile(ConvertToEnDigit(loginFormData.username))) {
                errorCount++;
                errorMessage = 'آدرس ایمیل یا شماره موبایل معتبر نیست';
            } else {
                errorCount--;
            }
            if (!ValidateEmail(ConvertToEnDigit(loginFormData.username))) {
                errorCount++;
                errorMessage = 'آدرس ایمیل یا شماره موبایل معتبر نیست';
            } else {
                errorCount--;
            }
            if (errorCount !== 0) {
                isRequired = true;
                setRequired(prevRequired => { return { ...prevRequired, username: { value: true, message: errorMessage } } });
            } else {
                isRequired = false;
                setRequired(prevRequired => { return { ...prevRequired, username: { value: false, message: '' } } });
            }
        }
        if (state.segValue !== 'code') {
            if (loginFormData.password.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, password: { value: true, message: 'الزامی' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, password: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (!isRequired) {
            if (state.segValue === 'code') {
                submitVerifyTemp();
            } else {
                submitLogin();
            }
        }
    }
    const handleBlur = () => {
        if (loginFormData.username.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, username: { value: true, message: 'الزامی' } } });
        } else {
            let errorCount = 0;
            let errorMessage = '';
            if (!ValidateIranMobile(ConvertToEnDigit(loginFormData.username))) {
                errorCount++;
                errorMessage = 'آدرس ایمیل یا شماره موبایل معتبر نیست';
            } else {
                errorCount--;
            }
            if (!ValidateEmail(ConvertToEnDigit(loginFormData.username))) {
                errorCount++;
                errorMessage = 'آدرس ایمیل یا شماره موبایل معتبر نیست';
            } else {
                errorCount--;
            }
            if (errorCount !== 0) {
                setRequired(prevRequired => { return { ...prevRequired, username: { value: true, message: errorMessage } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, username: { value: false, message: '' } } });
            }
        }
        if (state.segValue !== 'code') {
            if (loginFormData.password.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, password: { value: true, message: 'الزامی' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, password: { value: false, message: '' } } });
            }
        }
    }
    const handleVerifySubmit = (event = null as any) => {
        let isRequired = false;
        if (event !== null) {
            event.preventDefault();
        }
        if (loginFormData.verify_code.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, verify_code: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, verify_code: { value: false, message: '' } } });
            isRequired = false;
        }
        if (!isRequired) {
            submitLoginByVerifyCode();
        }
    }
    const smsRetriever = () => {
        return new Promise((resolve, reject) => {
            SmsRetriever.startWatching().then((response: any) => {
                let verifyCode = response.Message as any;
                verifyCode = verifyCode.replace('OLVOSiDtbts', '');
                verifyCode = verifyCode.match(/\d/g) as any;
                verifyCode = verifyCode.join("");
                resolve(verifyCode);
            }).catch((err) => {
                reject(err);
                console.log(err);
            });
        });
    };
    const submitVerifyTemp = async () => {
        setLoginFormData({ ...loginFormData, verify_code: '' })
        setLoading(true);
        let verifyTempData = new FormData();
        verifyTempData.append("username", loginFormData.username);
        try {
            const verifyTempResults = await axios.post(authVerifyTemp, verifyTempData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (verifyTempResults.data.result === 'error') {
                showToast({ message: verifyTempResults.data.message, color: 'danger' });
                if (verifyTempResults.data.message === 'اطلاعات وارد شده در سیستم وجود ندارد، لطفا ابتدا ثبت نام کنید.') {
                    props.loginErrorParentCallback('register');
                } else {
                    props.loginErrorParentCallback('login');
                }
                setLoading(false);
            } else {
                showToast({ message: verifyTempResults.data.message, color: 'success' });
                setState({ ...state, showVerifyCode: true, showVerifyCounter: true });
                setLoading(false);
                props.isVerifyTempParentCallback(true);
                verifyCounter();
            }
        } catch (error) {
            console.log(error);
            setState({ ...state, showVerifyCode: false, showVerifyCounter: false });
            setLoading(false);
        }
    }
    useEffect(() => {
        if (state.showVerifyCode) {
            smsRetriever().then((response: any) => {
                setLoginFormData({ ...loginFormData, verify_code: response });
            }).catch((err) => {
                showToast({ message: err, color: 'danger' });
                console.log(err);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showVerifyCode])
    const verifyCodeRef = useRef(false);
    useEffect(() => {
        if (!verifyCodeRef.current) {
            if (loginFormData.verify_code) {
                handleVerifySubmit();
            }
            verifyCodeRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginFormData.verify_code]);
    const submitLoginByVerifyCode = async () => {
        setLoading(true);
        let loginByVerifyCodeData = new FormData();
        loginByVerifyCodeData.append("username", loginFormData.username);
        loginByVerifyCodeData.append("verify_code", loginFormData.verify_code);
        try {
            const loginByVerifyCodeResults = await axios.post(authLoginByVerifyCode, loginByVerifyCodeData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (loginByVerifyCodeResults.data.result === 'error') {
                setLoginFormData({
                    username: '',
                    password: '',
                    verify_code: ''
                });
                showToast({ message: loginByVerifyCodeResults.data.message, color: 'danger' });
                setLoading(false);
            } else {
                let token = loginByVerifyCodeResults.data.token;
                getProfileInfo(token);
                showToast({ message: loginByVerifyCodeResults.data.message, color: 'success' });
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    const submitLogin = async () => {
        setLoading(true);
        let loginData = new FormData();
        loginData.append("username", loginFormData.username);
        loginData.append("password", loginFormData.password);
        try {
            const loginResults = await axios.post(authLogin, loginData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (loginResults.data.result === 'error') {
                setLoginFormData({
                    username: '',
                    password: '',
                    verify_code: ''
                });
                showToast({ message: loginResults.data.message, color: 'danger' });
                props.loginErrorParentCallback(true);
                setState({ ...state, showVerifyCode: false, showVerifyCounter: true });
                setLoading(false);
            } else {
                let token = loginResults.data.token;
                getProfileInfo(token);
                showToast({ message: loginResults.data.message, color: 'success' });
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    const getProfileInfo = async (token: any) => {
        try {
            const profileInfoResults = await axios.get(profileInfo, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            });
            if (profileInfoResults.data.result === 'error') {
                setLoginFormData({
                    username: '',
                    password: '',
                    verify_code: ''
                });
                showToast({ message: profileInfoResults.data.message, color: 'danger' });
                setLoading(false);
            } else {
                profileInfoResults.data.token = token;
                const setUserData = async () => {
                    await Storage.set({
                        key: 'userData',
                        value: JSON.stringify(profileInfoResults.data),
                    });
                };
                setUserData();
                setLoading(false);
                props.isLoginParentCallback(true);
                props.closeModalParentCallback(true);
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    const forgotPassword = () => {
        props.loginForgotParentCallback(true);
    };
    const verifyCounter = () => {
        setTimeout(() => {
            let verifyCountdown = '' as any;
            let now = moment(new Date()).add(2, 'm').add(1, 's').toDate();
            let verifyCounterEl = document.getElementById('verifyCounterEl') as any;
            let x = setInterval(function () {
                verifyCountdown = Countdown(now);
                if (verifyCountdown === false) {
                    clearInterval(x);
                    setState({ ...state, showVerifyCode: true, showVerifyCounter: false });
                    return;
                }
                if (verifyCounterEl) {
                    verifyCounterEl.innerHTML = verifyCountdown;
                }
            }, 1000);
        }, 1);
    }
    return (
        <div className="form-login-container">
            {!state.showVerifyCode ?
                <form onSubmit={handleLoginSubmit}>
                    {!loading ?
                        <IonGrid>
                            <IonRow>
                                <IonCol size="12">
                                    <h3 className="form-login-title">فرم ورود</h3>
                                    <div className="form-login-input-container">
                                        <IonRow>
                                            <IonCol size="12">
                                                <IonSegment onIonChange={e => setState({ ...state, segValue: e.detail.value! })} value={state.segValue} className="password-code-segment" mode="ios">
                                                    <IonSegmentButton value="password">
                                                        <IonLabel>ورود با کلمه عبور</IonLabel>
                                                    </IonSegmentButton>
                                                    <IonSegmentButton value="code">
                                                        <IonLabel>ورود با رمز موقت</IonLabel>
                                                    </IonSegmentButton>
                                                </IonSegment>
                                            </IonCol>
                                            {state.segValue === 'code' ?
                                                <IonCol size="12">
                                                    <IonLabel>
                                                        ایمیل یا شماره موبایل خود را وارد کنید تا رمز عبور موقت برای شما ارسال شود
                                                        {required.username.value ? <span className="required">{required.username.message}</span> : null}
                                                    </IonLabel>
                                                    <IonInput type="text" name="username" value={loginFormData.username || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur} />
                                                </IonCol>
                                                :
                                                <>
                                                    <IonCol size="12">
                                                        <IonLabel>
                                                            ایمیل یا شماره موبایل
                                                            {required.username.value ? <span className="required">{required.username.message}</span> : null}
                                                        </IonLabel>
                                                        <IonInput type="text" name="username" value={loginFormData.username || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur} />
                                                    </IonCol>
                                                    <IonCol size="12">
                                                        <IonLabel className="form-login-password-label">
                                                            <span>
                                                                رمز عبور
                                                                {required.password.value ? <span className="required">{required.password.message}</span> : null}
                                                            </span>
                                                            <span className="form-login-forgot">
                                                                رمز عبور خود را
                                                                <span onClick={forgotPassword}>
                                                                    فراموش کرده ام
                                                                </span>
                                                            </span>
                                                        </IonLabel>
                                                        <IonInput
                                                            type="password"
                                                            id="passwordPass"
                                                            name="password"
                                                            value={loginFormData.password || ""}
                                                            onIonChange={e => handleChange(e)}
                                                            onIonBlur={handleBlur}
                                                        />
                                                        <IonIcon
                                                            icon={eyeOutline}
                                                            id="passwordPassIcon"
                                                            className="toggle-password"
                                                            onClick={() => { TogglePassword("passwordPass", "passwordText", "passwordPassIcon", "passwordTextIcon") }}
                                                        />
                                                        <IonInput
                                                            type="text"
                                                            id="passwordText"
                                                            name="password"
                                                            value={loginFormData.password || ""}
                                                            onIonChange={e => handleChange(e)}
                                                            onIonBlur={handleBlur}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <IonIcon
                                                            icon={eyeOffOutline}
                                                            id="passwordTextIcon"
                                                            className="toggle-password"
                                                            onClick={() => { TogglePassword("passwordPass", "passwordText", "passwordPassIcon", "passwordTextIcon") }}
                                                            style={{ display: 'none' }}
                                                        />
                                                    </IonCol>
                                                </>
                                            }
                                            <IonCol size="12">
                                                <IonButton type="submit" color="warning" expand="block" className="form-login-submit-button">
                                                    ورود
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        :
                        <Loading />
                    }
                </form>
                :
                <form onSubmit={handleVerifySubmit}>
                    <div className="form-login-input-container">
                        <h3 className="form-login-title">تایید ورود</h3>
                        <IonGrid>
                            <IonRow>
                                <IonCol size="12">
                                    <IonLabel>
                                        کد ارسال شده برای موبایل / ایمیل را وارد کنید
                                        {required.verify_code.value ? <span className="required">{required.verify_code.message}</span> : null}
                                    </IonLabel>
                                    <IonInput type="tel" name="verify_code" value={loginFormData.verify_code || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur} />
                                </IonCol>
                                <IonCol size="12">
                                    <IonButton color="warning" expand="block" type="submit" className="form-login-submit-button">
                                        بررسی کد
                                    </IonButton>
                                </IonCol>
                                <IonCol size="12" className="ion-text-end">
                                    {state.showVerifyCounter ?
                                        <span id="verifyCounterEl" className="verify-counter"></span>
                                        :
                                        <div className="resend-verify" onClick={submitVerifyTemp}>
                                            ارسال مجدد
                                            <IonIcon icon={refreshImg} />
                                        </div>
                                    }
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                </form>
            }
        </div>
    );
};
export default Login;